<template>
  <div class="my-data-panel">
    <div class="panel-header">
      <h2 class="panel-title">个人信息与账户资料</h2>
      <p class="panel-desc">查看并管理您的采购企业账户基本信息，如需变更联系方式请在此更新</p>
    </div>

    <div class="profile-card">
      <div class="profile-header-summary">
        <div class="avatar-box">
          <i class="el-icon-user-solid"></i>
        </div>
        <div class="user-meta">
          <div class="name-row">
            <span class="user-display-name">{{ nickname || '企业采购员' }}</span>
            <span class="corp-role-tag">已认证采购账号</span>
          </div>
          <div class="account-code">登录账号: {{ email || '未绑定账号' }}</div>
        </div>
      </div>

      <el-form label-width="100px" size="medium" class="profile-form">
        <el-form-item label="登录账号">
          <el-input :value="email" disabled placeholder="登录账号不可更改"></el-input>
        </el-form-item>

        <el-form-item label="用户昵称">
          <el-input v-model="nickname" placeholder="请输入用户昵称"></el-input>
        </el-form-item>

        <el-form-item label="默认联系人">
          <el-input v-model="recipient" placeholder="请输入常用收件人姓名"></el-input>
        </el-form-item>

        <el-form-item label="联系电话">
          <el-input v-model="phone" placeholder="请输入常用联系电话"></el-input>
        </el-form-item>

        <el-form-item label="默认地址">
          <el-input v-model="address" type="textarea" :rows="2" placeholder="请输入常用详细收货地址"></el-input>
        </el-form-item>

        <el-form-item class="form-actions">
          <el-button type="primary" class="btn-save" :loading="saving" @click="updateUserData">
            保存资料
          </el-button>
          <el-button @click="showPopup" class="btn-pwd">
            修改安全密码
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 弹窗修改密码 -->
    <el-dialog
      title="修改登录密码"
      :visible.sync="popupShow"
      width="440px"
      :close-on-click-modal="false"
      custom-class="gov-address-dialog"
    >
      <el-form label-width="90px" size="medium">
        <el-form-item label="旧密码" required>
          <el-input type="password" show-password v-model="oldPwd" placeholder="请输入当前旧密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码" required>
          <el-input type="password" show-password v-model="newPwd" placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" required>
          <el-input type="password" show-password v-model="confirmPwd" placeholder="请再次输入新密码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closePopup">取消</el-button>
        <el-button type="primary" :loading="pwdLoading" @click="updatePwd">确认修改</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { getUserData, updateUserData, updatePwd } from "../../api/client";

export default {
  name: "MyData",
  computed: {
    ...mapState(["clientToken"]),
  },
  data() {
    return {
      id: "",
      headimg: "",
      email: "",
      nickname: "",
      recipient: "",
      address: "",
      phone: "",
      popupShow: false,
      saving: false,
      pwdLoading: false,
      oldPwd: "",
      newPwd: "",
      confirmPwd: "",
    };
  },

  methods: {
    ...mapMutations({
      setClientName: "SET_CLIENT_NAME",
    }),
    async updateUserData() {
      this.saving = true;
      try {
        await updateUserData({
          id: this.id,
          nickname: this.nickname,
          recipient: this.recipient,
          address: this.address,
          phone: this.phone,
        });
        this.$message.success("个人资料保存成功！");
        this.setClientName(this.nickname);
      } catch (e) {
        this.$message.error(e && e.message ? e.message : '保存失败，请稍后重试');
      } finally {
        this.saving = false;
      }
    },
    closePopup() {
      this.popupShow = false;
      this.oldPwd = "";
      this.newPwd = "";
      this.confirmPwd = "";
    },
    showPopup() {
      this.popupShow = true;
    },
    async updatePwd() {
      if (!this.oldPwd) return this.$message.warning("请输入原密码");
      if (!this.newPwd) return this.$message.warning("请输入新密码");
      if (this.newPwd !== this.confirmPwd) {
        return this.$message.warning("两次输入的密码不一致！");
      }
      this.pwdLoading = true;
      try {
        await updatePwd({
          id: this.id,
          oldPwd: this.oldPwd,
          newPwd: this.newPwd,
          confirmPwd: this.confirmPwd,
        });
        this.closePopup();
        this.$message.success("修改密码成功！");
      } catch (e) {
        this.$message.error(e && e.message ? e.message : '修改密码失败');
      } finally {
        this.pwdLoading = false;
      }
    },
  },

  mounted() {
    // 兼容原逻辑，如果有 clientToken 可获取
    if (this.clientToken) {
      getUserData(this.clientToken).then(data => {
        if (data) {
          this.id = data.id || '';
          this.headimg = data.headimg || '';
          this.email = data.email || '';
          this.nickname = data.nickname || '';
          this.recipient = data.recipient || '';
          this.address = data.address || '';
          this.phone = data.phone || '';
        }
      }).catch(() => {});
    }
  },
};
</script>

<style scoped lang="less">
@import "../../assets/css/var.less";

.my-data-panel {
  width: 100%;

  .panel-header {
    padding-bottom: 16px;
    margin-bottom: 24px;
    border-bottom: 1px solid #f1f5f9;

    .panel-title {
      font-size: 16px;
      font-weight: 700;
      color: #0f172a;
      margin: 0 0 6px;
    }

    .panel-desc {
      font-size: 13px;
      color: #64748b;
      margin: 0;
    }
  }

  .profile-card {
    max-width: 580px;

    .profile-header-summary {
      display: flex;
      align-items: center;
      gap: 16px;
      padding: 16px;
      background: #f8fafc;
      border: 1px solid #e2e8f0;
      border-radius: 8px;
      margin-bottom: 24px;

      .avatar-box {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        background: linear-gradient(135deg, @brandPrimary, @brandSecondary);
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        font-size: 26px;
        box-shadow: 0 4px 10px rgba(15, 82, 186, 0.2);
      }

      .user-meta {
        .name-row {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 4px;

          .user-display-name {
            font-size: 16px;
            font-weight: 700;
            color: #0f172a;
          }

          .corp-role-tag {
            font-size: 11px;
            color: #10b981;
            background: #ecfdf5;
            padding: 2px 8px;
            border-radius: 10px;
            border: 1px solid #a7f3d0;
            font-weight: 500;
          }
        }

        .account-code {
          font-size: 13px;
          color: #64748b;
        }
      }
    }

    .profile-form {
      .form-actions {
        margin-top: 28px;

        .btn-save {
          background-color: @brandPrimary;
          border-color: @brandPrimary;
          font-weight: 600;
          padding: 10px 24px;
          border-radius: 6px;

          &:hover {
            background-color: @brandSecondary;
            border-color: @brandSecondary;
            box-shadow: 0 4px 12px rgba(15, 82, 186, 0.25);
          }
        }

        .btn-pwd {
          margin-left: 12px;
          border-color: #cbd5e1;
          color: #475569;

          &:hover {
            color: @brandPrimary;
            border-color: @brandPrimary;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/client/MyData.vue